import { Position } from '../../../shared/types/protocol.ts';
import { Protocol, RecordPosition } from '../../types/sharedTypeImpl.ts';
import { reportError } from '../../utils/errorReporting.ts';


export function getWayOutOfSpecValues(
    protocol: Protocol,
    recordPositions: RecordPosition[],
): { position: Position, recordPosition: RecordPosition }[] {
    const out = [];
    for (const recordPosition of recordPositions) {
        const position = protocol.positions.find(it => it.positionNumber === recordPosition.positionNumber);
        if (!position) {
            reportError(`Position ${recordPosition.positionNumber} not found in protocol`);
            continue;
        }

        if (position.type !== 'measurement') continue;
        const { nominal, lowerTolerance, upperTolerance } = position;

        const value = +recordPosition.value!;
        if (!value) continue;

        let isWayOutOfSpec = false;
        if (+lowerTolerance! || +upperTolerance!) {
            const avgTolerance = (Math.abs(+lowerTolerance!) + +upperTolerance!) / 2;
            const toleranceRatio = Math.max(
                Math.abs(value - +nominal!) / Math.max(Math.abs(+lowerTolerance!), avgTolerance),
                Math.abs(value - +nominal!) / Math.max(Math.abs(+upperTolerance!), avgTolerance)
            );

            isWayOutOfSpec = toleranceRatio > 10;
        } else {
            const nominalRatio = Math.abs(value - +nominal!) / +nominal!;
            isWayOutOfSpec = nominalRatio > 0.5;
        }

        if (isWayOutOfSpec) {
            out.push({
                position,
                recordPosition,
            });
        }
    }
    return out;
}
